import { useSearchParams } from 'react-router';

/**
 * Host surface the Guardian app is embedded in, read from the `?source=` URL
 * query param and forwarded to the backend as the `source` request parameter.
 *
 * When the param is absent (or holds an unknown value) the hook returns
 * `undefined` and callers omit `source` entirely, letting the backend apply its
 * own default — we never invent a value the embedder did not provide.
 *
 * `ring_ui` is sent by the RING console even though guardian-backend does not
 * yet accept it (the generated client enums only have `portal | artesca_ui`).
 * Callers cast to the generated enum at the API boundary; the value is still
 * sent over the wire. The backend follow-up that adds `ring_ui` will close the
 * type gap.
 */
export const SOURCES = ['portal', 'artesca_ui', 'customer_portal', 'ring_ui', 'adi_ui'] as const;
export type Source = (typeof SOURCES)[number];

const isSource = (value: string | null): value is Source =>
  value != null && (SOURCES as readonly string[]).includes(value);

export const useSource = (): Source | undefined => {
  const [searchParams] = useSearchParams();
  const source = searchParams.get('source');
  return isSource(source) ? source : undefined;
};
